export default "__VITE_ASSET__BUko$yVI__"